import { gql } from '@apollo/client';

export const GET_INVITE_BY_TOKEN = gql`
  query GetInviteByToken($token: String!) {
    getInviteByToken(token: $token) {
      id
      email
      firstName
      lastName
      status
      createdAt
      expiresAt
      company {
        id
        name
        industry
        companyDescription
      }
    }
  }
`;

export const GET_COMPANY_INVITES = gql`
  query GetCompanyInvites {
    getCompanyInvites {
      id
      email
      firstName
      lastName
      status
      createdAt
      expiresAt
      invitedBy {
        id
        firstName
        lastName
        email
      }
      acceptedBy {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
